// Adapted from THREE example by @aleeper & @mrdoob
import {BackSide, Vector3} from 'three'
import RenderEventDispatcher from './eventDispatcher'

class GenericLoader extends RenderEventDispatcher {
  static extensions() {
    this.extensions = {}
  }

  static loaderForUrl(status, url = '') {
    // If we're asked to load literally nothing, we'll
    // go ahead and do that.
    if (!url || url.trim() === '') {
      return new this.extensions.noop(status)
    }

    const [file] = url.split('?')
    const result = (file || '').match(/\.([^.]*)$/)

    if (result) {
      const ext = (result[1] || '').toLowerCase()

      if (this.extensions[ext]) {
        return new this.extensions[ext](status)
      }
    }

    // We cant find a loader, so exploooode
    throw new Error(`No fitting loader for url [${url}]`)
  }

  constructor(status) {
    super()
    this.status = status
    this.afterLoadSuccess = this.afterLoadSuccess.bind(this)
  }

  calculateNormal(geometry, index1, index2, index3) {
    const v1 = new Vector3().subVectors(geometry.vertices[index1], geometry.vertices[index2])
    const v2 = new Vector3().subVectors(geometry.vertices[index1], geometry.vertices[index3])
    return new Vector3().crossVectors(v1, v2).normalize()
  }

  side() {
    return BackSide
  }

  afterLoadSuccess(data) {
    const object = this.parse(data)
    if (object) {
      this.dispatchEvent({
        type: 'load',
        content: object
      })
    } else {
      this.dispatchEvent({
        type: 'error:fatal',
        message: 'Model not valid.'
      })
    }
  }

  load(url, options = {}) {
    window.debug(`Attempting to load URL: [${url}]`)

    this.status.load(url, {
      attempts: options.attempts,
      success: this.afterLoadSuccess,
      error: (_, xhr) => {
        const statusCode = xhr.status
        const type = statusCode === 403 ? 'error:fatal' : 'error'

        this.dispatchEvent({
          type,
          message: `Could not load URL [${url}] [${statusCode}]`
        })
      },

      before: xhr => {
        // Ideally, I could set the `.responseType = "arraybuffer"`
        // on the XMLHttpRequest object directly and get a typed buffer
        // back, but I cannot using jQuery abstractions :(
        xhr.overrideMimeType('text/plain; charset=x-user-defined')
      }
    })
  }
}

GenericLoader.extensions()
export default GenericLoader
